import { useContext } from 'react';
import { recoilScopeContext } from '../contexts/recoilScopeContext';
import { RecoilValue, ScopedNode, isScopedNode } from '../recoil';

export const useRecoilScope = () => useContext(recoilScopeContext);

export const useResolveNode = <T, N extends RecoilValue<T>>(
  node: N | ScopedNode<N>
) => (isScopedNode(node) ? node(useRecoilScope()) : node);
